const artists = [
  {
    name: 'Tia Wenrich',
    phone: '316-880-7760',
    instagram: 'https://www.instagram.com/tiatnttheneedletemptress/',
    specialty: 'Body, Ear, Face & Custom Piercings',
    bio: 'Tia is a master of precision and artistry, specializing in intricate ear curations and facial piercings. With years of experience and an eye for detail, she creates stunning piercing arrangements that complement each client\'s unique features and style.',
    image: 'https://static.readdy.ai/image/ec7d44241e5d5731ab0de78142a46920/9601adb3e056f3e39b42dfaa05615e7b.png',
    gallery: [
      'https://static.readdy.ai/image/ec7d44241e5d5731ab0de78142a46920/9c3ddce864ad3333b93f64c059175554.png',
      'https://static.readdy.ai/image/ec7d44241e5d5731ab0de78142a46920/136a7f3cc9a440c2a6a90c74e86dc350.png',
      'https://static.readdy.ai/image/ec7d44241e5d5731ab0de78142a46920/ab79d801892bbea0c1b7e41a683e36eb.png'
    ]
  },
  {
    name: 'Justin Wenrich',
    phone: '316-305-7076',
    instagram: 'https://www.instagram.com/justinwenrichpiercer/',
    specialty: 'Body, Ear, Face & Custom Piercings',
    bio: 'Justin brings bold creativity and technical expertise to every piercing. Specializing in body piercings and custom placements, he works closely with clients to bring their piercing visions to life while ensuring the highest standards of safety and professionalism.',
    image: 'https://static.readdy.ai/image/ec7d44241e5d5731ab0de78142a46920/d6eeb85e246004da58627b0524d8b2c9.png',
    gallery: [
      'https://static.readdy.ai/image/ec7d44241e5d5731ab0de78142a46920/a70ab5b1d8acbb21f4fa3c289d57cb33.png',
      'https://static.readdy.ai/image/ec7d44241e5d5731ab0de78142a46920/472d8323c3bb2921224e58e3c24d453d.png',
      'https://static.readdy.ai/image/ec7d44241e5d5731ab0de78142a46920/9acc31eb0c5bc48acbbc787e0061f722.png'
    ]
  }
];

export default function Artists() {
  return (
    <section id="artists" className="py-24 bg-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Meet Our Artists
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            Our experienced piercers combine technical expertise with artistic vision to deliver exceptional results.
          </p>
        </div>

        <div className="space-y-24">
          {artists.map((artist, index) => (
            <div 
              key={index}
              className={`grid grid-cols-1 lg:grid-cols-2 gap-12 items-start ${
                index % 2 === 1 ? 'lg:flex-row-reverse' : ''
              }`}
            >
              <div className={`${index % 2 === 1 ? 'lg:order-2' : ''}`}>
                <img
                  src={artist.image}
                  alt={artist.name}
                  className="w-full h-[600px] object-cover object-top rounded-2xl shadow-2xl"
                />
              </div>

              <div className={`${index % 2 === 1 ? 'lg:order-1' : ''}`}>
                <div className="bg-gray-800 p-8 rounded-2xl border border-gray-700">
                  <h3 className="text-3xl font-bold text-white mb-2">
                    {artist.name}
                  </h3>
                  <p className="text-red-500 font-bold text-lg mb-6">
                    {artist.specialty}
                  </p>
                  <p className="text-gray-300 mb-6 leading-relaxed">
                    {artist.bio}
                  </p>

                  <div className="space-y-3 mb-8">
                    <div className="flex items-center gap-3">
                      <i className="ri-phone-line text-red-500 text-xl"></i>
                      <a 
                        href={`tel:${artist.phone.replace(/-/g, '')}`}
                        className="text-gray-300 hover:text-red-500 transition-colors cursor-pointer"
                      >
                        {artist.phone}
                      </a>
                    </div>
                    <div className="flex items-center gap-3">
                      <i className="ri-instagram-line text-red-500 text-xl"></i>
                      <a 
                        href={artist.instagram}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-gray-300 hover:text-red-500 transition-colors cursor-pointer"
                      >
                        @{artist.instagram.split('/')[3]}
                      </a>
                    </div>
                  </div>

                  <div>
                    <h4 className="text-xl font-bold text-white mb-4">
                      Recent Work
                    </h4>
                    <div className="grid grid-cols-3 gap-4">
                      {artist.gallery.map((image, imgIndex) => (
                        <img
                          key={imgIndex}
                          src={image}
                          alt={`${artist.name}'s work ${imgIndex + 1}`}
                          className="w-full h-32 object-cover object-top rounded-lg hover:scale-105 transition-transform cursor-pointer"
                        />
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}